import { render } from "./SolidCheckCircle.svg?vue&type=template&id=14c2e60c"
const script = {}
script.render = render

export default script